import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { GlobalAlert } from '../../../global/components/GlobalAlert';

export const ModGroupModal = ({
  show,
  onHide,
  modalMode,
  modGroupFormData,
  setModGroupFormData,
  handleModGroupSubmit,
  error,
  setError
}) => {
  return (
    <Modal show={show} onHide={onHide} centered size="sm">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title style={{ color: "#1e3c72", fontWeight: 700 }}>
          {modalMode === "add" ? "Modifier Group" : "Edit Group"}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleModGroupSubmit}>
        <Modal.Body>
          <GlobalAlert message={error} onClose={() => setError("")} />
          <Form.Group className="mb-3">
            <Form.Label>Group Name</Form.Label>
            <Form.Control 
              type="text" 
              required 
              value={modGroupFormData.name} 
              onChange={(e) => setModGroupFormData({...modGroupFormData, name: e.target.value})} 
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Check 
              type="checkbox" 
              label="Is Required?" 
              checked={modGroupFormData.is_required} 
              onChange={(e) => setModGroupFormData({...modGroupFormData, is_required: e.target.checked})} 
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Max Choices</Form.Label>
            <Form.Control 
              type="number" 
              min="1" 
              required 
              value={modGroupFormData.max_choices} 
              onChange={(e) => setModGroupFormData({...modGroupFormData, max_choices: e.target.value})} 
            />
          </Form.Group>
          <Form.Group>
            <Form.Check 
              type="switch"
              id="group-active-switch"
              label={<span className="fw-bold text-secondary">Active (เปิดใช้งาน)</span>}
              checked={modGroupFormData.is_active}
              onChange={(e) => setModGroupFormData({...modGroupFormData, is_active: e.target.checked})}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 mt-3">
          <Button variant="light" onClick={onHide}>Cancel</Button>
          <Button variant="primary" type="submit" style={{ background: "#1e3c72", border: "none" }}>Save</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
